<script setup>
import {onMounted, onUnmounted, ref} from 'vue';
import LoadingComponent from "@/components/utils/LoadingComponent.vue";
import { trackScreenSize } from "@/globals/utils/getScreenSize";
import { formatDate } from "@/globals/utils/formatDate";
import {customToast} from "@/globals/utils/customToast";
import {acceptRide, cancelRide, getRides} from "@/services/tripService";
import MailTo from "@/components/utils/MailTo.vue";
import PhoneCall from "@/components/utils/PhoneCall.vue";
import ConfirmModal from "@/components/utils/ConfirmModal.vue";
import AssignDriverModal from "@/components/pages/admin/trip/components/AssignDriverModal.vue";
import socket from "@/services/socket";
import {useRoute} from "vue-router";
import router from "@/router";
import FloatingButtonAction from "@/components/utils/FloatingButtonAction.vue";

const trips = ref([]);
const loading = ref(true);
const error = ref(null);
// const searchQuery = ref('');
const screenInfo = ref({ width: 0, height: 0, deviceType: "DESKTOP" });
let removeListener;

// Variables reactivas
const route = useRoute();
const statusList = ref(['all', 'pending', 'accepted', 'in_your_location', 'in_progress', 'completed', 'cancelled', 'reserved']);
const status = ref(route.params.status || 'all');

console.log('status', status.value);

// Modal constants
const showConfirmModal = ref(false)
const modalTitle = ref('Eliminar elemento')
const modalMessage = ref('¿Estás seguro que deseas eliminar este elemento? Esta acción no se puede deshacer.')
const selectedTrip = ref(null)

// Modal Assign Driver
const showAssignDriverModal = ref(false)

// Función para abrir el modal de assign
const assignDriverModal = (trip) => {
  selectedTrip.value = trip
  showAssignDriverModal.value = true
}

// handleConfirmDriver
const handleConfirmDriver = async  (driver)  => {
  // Lógica de asignación de conductor onbtener el conductor seleccionado
  if (driver) {
    loading.value = true;
    try {
      // Lógica de asignación de conductor
      await acceptRide(selectedTrip.value._id, driver._id);
      showAssignDriverModal.value = false; // Cierra el modal
      // Actualizar la lista de viajes
      await fetchTrips();
      customToast('Driver assigned successfully!', 'success');
      loading.value = false;
    }
    catch (err) {
      showAssignDriverModal.value = true;
      loading.value = false;
      customToast(`Driver unassigned!`, 'error');
    }
  } else {
    customToast('Need select a driver!', 'error');
  }
}

// handleCancelDriver
const handleCancelDriver = () => {
  showAssignDriverModal.value = false
}

// Obtener la lista de viajes al montar el componente
const fetchTrips = async () => {
  loading.value = true;
  try {
    // Obtener los viajes según el estado
    if(status.value === 'all'){
      trips.value = await getRides('');
    }else{
      trips.value = await getRides(status.value);
    }
  } catch (err) {
    error.value = 'Error al cargar los viajes.';
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// handleCancelConfirm
const handleConfirm = async () => {
  showConfirmModal.value = false
  try {
    // Lógica de cancelación
    await cancelRide(selectedTrip.value._id);
    // Cambiar el estado del viaje a cancelado
    selectedTrip.value.status = 'cancelled';
    customToast('Viaje cancelado correctamente.', 'success');
  }
  catch (err) {
    customToast('Error al cancelar el viaje.', 'error');
  }
}

// handleCancelCancel
const handleCancel = () => {
  // Lógica de cancelación
  showConfirmModal.value = false
}

// Por ejemplo, para abrir el modal:
const openModal = (trip) => {
  selectedTrip.value = trip
  modalTitle.value = 'Cancel trip'
  modalMessage.value = `Are you sure you want to cancel the trip from ${trip.pickup.address} to ${trip.destination.address}?`
  console.log('selectedTrip', selectedTrip.value)
  showConfirmModal.value = true
}

// Al montar el componente
onMounted(() => {
  // Obtener la lista de viajes
  fetchTrips();
  // Obtener el tamaño de la pantalla
  removeListener = trackScreenSize((info) => {
    screenInfo.value = info;
  });

  // Conectar al socket
  socket.connect();

  // Escuchar un evento específico
  socket.on("newRide", (data) => {
    try {
      //Add result to the list prepend at the beginning
      trips.value.unshift(data);
      if (data) {
        customToast('New Trip created', 'success');
      }
      console.log("newRide:", data);
    } catch (error) {
      console.error("Error procesando el mensaje:", error);
    }
  });

  // Escuchar cambios en el estado de los rides
  socket.on("rideStatusUpdated", (data) => {
    try {
      // buscarlo por el _id y actualizarlo
      const index = trips.value.findIndex(trip => trip._id === data._id);
      if (index !== -1) {
        trips.value[index].status = data.status;
        if(trips.value[index].status === 'accepted'){
          trips.value[index].driver = data.driver;
        }
        customToast('Trip status updated', 'success');
      }
      console.log("rideStatus:", data);
    } catch (error) {
      console.error("Error procesando el mensaje:", error);
    }
  });

  // Escuchar cambios en el estado de los rides
  socket.on("rideAccepted" , (data) => {
    try {
      // buscarlo por el _id y actualizarlo
      const index = trips.value.findIndex(trip => trip._id === data._id);
      if (index !== -1) {
        trips.value[index].status = data.status;
        trips.value[index].driver = data.driver;
        customToast('Trip status updated', 'success');
      }
      console.log("rideAccepted:", data);
    } catch (error) {
      console.error("Error procesando el mensaje:", error);
    }
  });

  console.log("socket", socket.connected);

});

// Al desmontar el componente
onUnmounted(() => {
  // Remover el listener al desmontar el componente
  if (removeListener) removeListener();
  // Desconectar el socket y limpiar eventos
  socket.off("newRide");
  socket.off("rideAccepted");
  socket.off("rideStatusUpdated");
  socket.disconnect();
});

// Función para manejar la eliminación de un viaje
// const deleteTripHandler = async (id) => {
//   if (confirm('¿Estás seguro de que deseas eliminar este viaje?')) {
//     try {
//       await deleteTrip(id);
//       // Remover el viaje de la lista localmente
//       trips.value = trips.value.filter(trip => trip._id !== id);
//       customToast('Viaje eliminado correctamente.', 'success');
//     } catch (err) {
//       customToast('Error al eliminar el viaje.', 'error');
//     }
//   }
// };

// cambiar la direcion de la pagina al cambiar el filtro
const changeStatus = async () => {
  if (status.value === 'all') {
    await router.push({name: 'Trips'});
  } else {
    await router.push({name: 'TripsByStatus', params: {status: status.value}});
  }
  await fetchTrips();
};

</script>

<template>
  <FloatingButtonAction path="/trips/create">
    <span class="material-icons mr-2">add_circle</span> Add Trip
  </FloatingButtonAction>
  <div class="flex justify-between items-center mb-4">
    <div class="flex items-center">
      <label for="status" class="block text-gray-700 dark:text-gray-300 font-medium mr-2">Filter by status:</label>
      <select
          id="status"
          v-model="status"
          @change="changeStatus"
          class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
      >
        <option v-for="item in statusList" :key="item" :value="item">{{ item }}</option>
      </select>
    </div>
  </div>

  <!-- Modals -->
  <ConfirmModal
      :show="showConfirmModal"
      :title="modalTitle"
      :message="modalMessage"
      :onConfirm="handleConfirm"
      :onCancel="handleCancel"
  />

  <AssignDriverModal
      :show="showAssignDriverModal"
      :trip="selectedTrip"
      :onConfirm="handleConfirmDriver"
      :onCancel="handleCancelDriver"
  />

  <LoadingComponent v-if="loading" />
  <div v-else>
    <div class="overflow-x-auto bg-white dark:bg-gray-800 rounded-lg shadow">
      <table class="min-w-full table-auto border-collapse" v-if="trips.length>0">
        <thead class="bg-gray-100 dark:bg-gray-700">
        <tr>
          <th v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Client</th>
          <th v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Driver</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Origin</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Destination</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Status</th>
          <th v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Date</th>
          <th v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Time</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="trip in trips" :key="trip._id" class="odd:bg-white even:bg-gray-50 dark:odd:bg-gray-700 dark:even:bg-gray-600 hover:bg-gray-100 dark:hover:bg-gray-500">
          <!-- Client -->
          <td v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-gray-700 dark:text-gray-300">
            <div v-if="trip.user">
              <strong>{{ trip.user.name }}</strong><br>
              <MailTo v-if="trip.user.email" :email="trip.user.email" /><br>
              <PhoneCall v-if="trip.user.phone" :phone="trip.user.phone" />
            </div>
            <div v-else class="text-gray-500 italic">No user data</div>
          </td>

          <!-- Driver -->
          <td v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-gray-700 dark:text-gray-300">
            <div v-if="trip.driver">
              <strong>{{ trip.driver.name }}</strong><br>
              <MailTo v-if="trip.driver.email" :email="trip.driver.email" /><br>
              <PhoneCall v-if="trip.driver.phone" :phone="trip.driver.phone" />
            </div>
            <div v-else>
              <button
                  v-if="trip.status === 'pending' || trip.status === 'reserved'"
                  class="flex items-center justify-center px-2 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded-md shadow focus:ring-2 focus:ring-blue-300"
                  @click="assignDriverModal(trip)"
              >
                <span class="material-icons">check</span> Assign Driver
              </button>
              <span v-else class="text-gray-500 italic">No driver assigned</span>
            </div>
          </td>

          <!-- Origin & Destination -->
          <td class="px-4 py-2 text-gray-700 dark:text-gray-300">{{ trip.pickup?.address || 'Unknown' }}</td>
          <td class="px-4 py-2 text-gray-700 dark:text-gray-300">{{ trip.destination?.address || 'Unknown' }}</td>

          <!-- Status -->
          <td class="px-4 py-2 text-center">
              <div
                  :class="{
                  'bg-red-500 text-white': trip.status === 'cancelled',
                  'bg-blue-500 text-white': trip.status === 'accepted',
                  'bg-yellow-500 text-black': trip.status === 'pending',
                  'bg-lime-500 text-white': trip.status === 'in_your_location',
                  'bg-orange-500 text-white': trip.status === 'in_progress',
                  'bg-emerald-500 text-white': trip.status === 'pending_payment',
                  'bg-green-500 text-white': trip.status === 'completed',
                }"
                  class="px-2 py-1 rounded-md font-semibold"
              >
                {{ trip.status.replace(/_/g, ' ')}}
              </div>
          </td>

          <!-- Date & Time -->
          <td v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-gray-700 dark:text-gray-300">{{ formatDate(trip.createdAt, "MM/DD/YYYY") }}</td>
          <td v-if="screenInfo.deviceType === 'DESKTOP'" class="px-4 py-2 text-gray-700 dark:text-gray-300">{{ formatDate(trip.createdAt, "HH:mm A") }}</td>

          <!-- Actions -->
          <td class="px-4 py-2">
            <div class="flex space-x-2">
              <!-- Info -->
              <button
                  title="Info"
                  @click="() => router.push({name: 'TripDetails', params: {id: trip._id}})"
                  class="px-2 py-1 bg-gray-500 hover:bg-gray-600 text-white rounded-md shadow"
              >
                <span class="material-icons" style="font-size: 16px;">info</span>
              </button>

              <!-- Cancel -->
              <button
                  v-if="trip.status !== 'cancelled' && trip.status !== 'completed'"
                  @click="openModal(trip)"
                  title="Cancel"
                  class="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded-md shadow"
              >
                <span class="material-icons" style="font-size: 16px;">cancel</span>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-else class="text-center text-gray-500 dark:text-gray-300 p-5">
        <span class="material-icons">info</span> No trips available
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Additional scoped styles if needed */
</style>

<style scoped>

</style>